import { useNavigate } from "react-router-dom";
import { Link } from "../../molecules/Link";
import { useDispatch } from "react-redux";
import { cerrarSesion } from "../../../store/slices/usuario.slice";
import { UsuarioMenu } from "../../molecules/UsuarioMenu";

export const AdministradorNavbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleLogout = () => {
    dispatch(cerrarSesion());
    navigate("/");
  };

  return (
    <div className="bg-theme-blue p-3 flex flex-col md:flex-row items-center justify-between relative">
      <nav className="flex flex-col md:flex-row items-center text-white w-full">
        {/* <div className="flex flex-row items-center gap-4 my-auto p-[1px] bg-yellow-400 px-2"> */}
        <Link route={"/inicio"} underline={true} end={false}>
          {"Inicio"}
        </Link>
        <Link route={"/PerfilAdm"} underline={true} end={false}>
          {"Perfil"}
        </Link>
        <Link route={"/estudiantes"} underline={true} end={false}>
          {"Estudiantes"}
        </Link>
        <Link route={"/docentes"} underline={true} end={false}>
          {"Docentes"}
        </Link>
        <Link route={"/programas"} underline={true} end={false}>
          {"Programas"}
        </Link>
        <Link route={"/idiomas"} underline={true} end={false}>
          {"Idiomas"}
        </Link>
        <Link route={"/grupos"} underline={true} end={false}>
          {"Grupos"}
        </Link>
        <Link route={"/notificaciones"} underline={true} end={false}>
          {"Notificaciones"}
        </Link>
        <Link route={"/pais"} underline={true} end={false}>
          {"País"}
        </Link>

        {/* </div> */}
      </nav>
      {/* <div className={"flex items-center md:ml-4 mt-4 md:mt-0 "}>
        <button
          className="bg-white bg-opacity-50 rounded-md px-3 py-2 text-white my-auto"
          onClick={handleLogout}
        >
          Cerrar sesión
        </button>
      </div> */}
      <UsuarioMenu />
    </div>
  );
};
